export interface StaySpan {
    startDate: string
    endDate: string
}

export interface Reservation {
    staySpan: StaySpan
    numberOfGuests: number
}

export interface CleaningInfo {
    listingId?: string
    listingName: string
    listingAddress: string
    otaInfo?: {
        otaName: string
        otaListingName: string
    }[]
    nextReservation?: Reservation
    thisReservation?: Reservation
    // YYYY-MM-DDの形式
    cleaningDate: string
    note?: string
    // DetaillsPage用に書いたが渡されて来ていない
    instruction?: undefined
    photoTourId?: string
    placement?: string
    commonAreaId?: string
}

export interface CleaningExtraInfo {
    sumycaListingId: string
}

export type CleaningStatus = "prepared" | "started" | "finished" | "reported"

export type CleaningType = "standard" | "intensive" | "simple" | "deepCleaning"

export interface Errand {
    id: string
    title: string
    description: string
    pictures: string[]
}

export type ErrandListType = Errand[]

export interface CleaningEvidence {
    imageId: string
    url: string
}

export interface TaskResult {
    taskId: string
    picturesDetail: { url: string }[]
}

export interface CleaningInfoDetailType {
    id: string
    errands?: Errand[]
    cleaningInfo: CleaningInfo
    status: CleaningStatus
    evidences?: CleaningEvidence[]
    taskResults?: TaskResult[]
    cleaningType: CleaningType
    scheduleStart?: number | null
    scheduleEnd?: number | null
    deadlineAt?: number | null
    cleaningCompanyId?: string | null
    cleaningCompanyName?: string | null
    cleaningCompanyMemo: string
}

export const displayCleaningType = (cleaningType: CleaningType): string => {
    switch (cleaningType) {
        case "standard":
            return "通常清掃"
        case "intensive":
            return "重点清掃"
        case "simple":
            return "簡易清掃"
        case "deepCleaning":
            return "ディープクリーニング"
        default:
            return "不明な清掃"
    }
}
